import * as config from "Config";
import * as constants from "./constants";


export function clearStore({onlyItem}) {
  if(onlyItem){
    return {
      type: constants.clearItemStore 
    };
  }
    return {
      type: constants.clearStore 
    };
}

export function initListData(params) {
    let url = config.apiUrl + "/api/Supplier";
    if (params.companyId) {
      url += "/Company/" + params.companyId+"/Summury";
    }
    if (params.companyGroupId) {
      url += "/CompanyGroup/" + params.companyGroupId+"/Summury";
    }

    return {
      remote:{
          method: "get",
          url,
          data:params
      },
      actions:[constants.listLoadStart,constants.listLoadSuccess,constants.listLoadFail ]
    };
}

export function saveNewItem(params) {
    let url = config.apiUrl + "/api/Supplier";
    if (params.companyId) {
      url += "/Company/" + params.companyId;
    }
    if (params.companyGroupId) {
      url += "/CompanyGroup/" + params.companyGroupId;
    }
  return {
    remote:{
        method: "post",
        url,
        data:params
    },
    actions:[constants.itemSaveStart,constants.itemSaveSuccess,constants.itemSaveFail ]
  };
}




export function initItemData(params) {
    let url = config.apiUrl + "/api/Supplier/" + params.id;
    if (params.companyId) {
      url += "/Company/" + params.companyId;
    }
    if (params.companyGroupId) {
      url += "/CompanyGroup/" + params.companyGroupId;
    }
  return {
    remote:{
        method: "get",
        url 
    },
    actions:[constants.itemLoadStart,constants.itemLoadSuccess,constants.itemLoadFail]
  };
}

export function deleteItem(params) {
    let url = config.apiUrl + "/api/Supplier/" + params.id;
    if (params.companyId) {
      url += "/Company/" + params.companyId;
    }
    if (params.companyGroupId) {
      url += "/CompanyGroup/" + params.companyGroupId;
    }
    return {
      remote:{
          method: "delete",
          url 
      },

      actions:[constants.itemDeleteStart,constants.itemDeleteSuccess,constants.itemDeleteFail]
    };
}


export function saveItem(params) {
    let url = config.apiUrl + "/api/Supplier";
    if (params.companyId) {
      url += "/Company/" + params.companyId;
    }
    if (params.companyGroupId) {
      url += "/CompanyGroup/" + params.companyGroupId;
    }

  return {
    remote:{
        method: "put",
        url,
        data:params
    },
    actions:[constants.itemSaveStart,constants.itemSaveSuccess,constants.itemSaveFail]
  };
}

